import { useGoogleLogin } from "@react-oauth/google";
import { useDispatch } from "react-redux";
import CryptoJS from "crypto-js";
import SC from "./style.js";
import googlelogo from "@assets/logo/google.png";
import { GoogleAuthAction } from "@store/auth/actions.js";

const { REACT_APP_CRYPTO_KEY } = process.env;

const encryptGoogleAuthValue = (value) => {
  return CryptoJS.AES.encrypt(value, REACT_APP_CRYPTO_KEY).toString();
};

const Googlesignin = (props) => {
  const { setShowModal = () => {}, handleReLogin = () => {} } = props;
  const dispatch = useDispatch();

  const responseMessage = (response) => {
    // Access-token flow fallback.
    // const accessToken = encryptGoogleAuthValue(response.access_token);
    // dispatch(
    //   GoogleAuthAction({ accessToken }, (success) => {
    //     if (success) {
    //       handleReLogin();
    //     }
    //   })
    // );

    if (!response?.code) {
      setShowModal(true);
      return;
    }

    const code = encryptGoogleAuthValue(response.code);

    dispatch(
      GoogleAuthAction({ code }, (success) => {
        if (success) {
          handleReLogin();
        }
      }),
    );
  };

  const errorMessage = (error) => {
    console.log(error);
    setShowModal(true);
  };
  const login = useGoogleLogin({
    // Access-token flow fallback.
    // flow: "implicit",
    flow: "auth-code",
    onSuccess: responseMessage,
    onError: errorMessage,
  });

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        width: "100%",
        justifyContent: "center",
        alignItems: "center",
        marginBottom: "-30px",
      }}
    >
      <SC.Button onClick={() => login()}>
        <SC.img src={googlelogo} alt="image" />
        <span>&nbsp; Sign in with Google</span>
      </SC.Button>
      <SC.MainDiv>
        <SC.ChildDivOneThree></SC.ChildDivOneThree>
        <SC.ChildDivTwo>Or</SC.ChildDivTwo>
        <SC.ChildDivOneThree></SC.ChildDivOneThree>
      </SC.MainDiv>
    </div>
  );
};
export default Googlesignin;
